import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/confirm-work-email/page";

export const Route = createFileRoute("/auth/confirm-work-email")({
  component: Page,
});
